import { createAction, props } from '@ngrx/store';

export const setBranchId = createAction(
  '[Branch] Set Branch Id',
  props<{ branch_id: string }>()
);

export const clearBranchId = createAction(
  '[Branch] Clear Branch Id'
);